import { AjaxAutocomplete } from '../form.components/autocomplete/autocomplete.jsx';
import AutocompleteCheckboxButtons from '../form.components/checkbox/autocomplete.checkbox.jsx';
import AutocompleteCheckboxButtonsWithAge from '../form.components/checkbox/autocomplete.checkbox.with.diagnosis.age.jsx';
import DateOfBirth from '../form.components/date.of.birth/date.of.birth.jsx';
import DontKnowBtn from '../form.components/dont.know.btn/dont.know.btn.jsx';
import CheckboxButtons from '../form.components/checkbox/checkbox.jsx';
import DropDown from '../form.components/dropdown/dropdown.jsx';
import FamilyCancerHistory from '../form.components/family.cancer.history/familiy.cancer.history.jsx';
import PersonsArray from '../form.components/persons.array/persons.array.jsx';
import RadioButtons, { YesNoButtons } from '../form.components/radio.buttons/radio.buttons.jsx';
import Slider from '../form.components/slider/slider.jsx';
import SmallInput from '../form.components/small.input/small.input.jsx';
import TextInput from '../form.components/text.input/text.input.jsx';
import NumberInput from '../form.components/number.input/number.input.jsx';
import Weight from '../form.components/weight.height/weight.jsx';
import Height from '../form.components/weight.height/height.jsx';
import Multibirth from '../form.components/multibirth/multibirth.jsx';
import UserComments from '../form.components/comments/user.comments.jsx';

export default {
    AjaxAutocomplete,
    DateOfBirth,
    DontKnowBtn,
    CheckboxButtons,
    AutocompleteCheckboxButtons,
    AutocompleteCheckboxButtonsWithAge,
    DropDown,
    FamilyCancerHistory,
    PersonsArray,
    RadioButtons,
    YesNoButtons,
    Slider,
    SmallInput,
    TextInput,
    NumberInput,
    Weight,
    Height,
    Multibirth,
    UserComments
};
